import { COMPLETION_CERTIFICATE_SHEET_NAME } from "./excel.service";
import { WI_INDEX_SHEET_NAME } from "./wi-index.service";

/**
 * Sheets that WFI generates or imports itself, rather than workpapers the
 * team prepares and reviews.
 *
 * These shouldn't get status items: nobody prepares, reviews or signs off a
 * trial-balance dump or the index sheet, so tracking them just adds noise to
 * the status-items table and the completion certificate.
 *
 * Single source of truth for the names — Setup writes the XERO sheets using
 * these same constants, so a rename can't leave the exclusion list pointing
 * at a name that no longer exists.
 */

export const XERO_SHEET_NAME = "XERO";
export const XERO_LY_SHEET_NAME = "XERO LY";
export const XERO_TB_SHEET_NAME = "XERO TB";

const NON_WORKPAPER_SHEET_NAMES = [
  COMPLETION_CERTIFICATE_SHEET_NAME,
  WI_INDEX_SHEET_NAME,
  XERO_SHEET_NAME,
  XERO_LY_SHEET_NAME,
  XERO_TB_SHEET_NAME,
].map((n) => n.toLowerCase());

/**
 * True when a sheet is WFI's own output rather than a workpaper.
 *
 * Compared case-insensitively and trimmed: Excel preserves whatever case a
 * sheet was created with but treats names case-insensitively, so a workbook
 * carrying "Xero LY" from an older import must still be recognised.
 */
export function isNonWorkpaperSheet(name: string): boolean {
  return NON_WORKPAPER_SHEET_NAMES.includes(name.trim().toLowerCase());
}
